package nl.astraeus.midi.audio

@ExperimentalJsExport
@JsExport
data class PatchDTO(
  @JsName("waveform")
  val waveform: Int = 0,
  @JsName("midiId")
  val midiId: String = "",
  @JsName("midiName")
  val midiName: String = "",
  @JsName("midiChannel")
  var midiChannel: Int = 0,
  @JsName("volume")
  var volume: Double = 0.75,
  @JsName("dutyCycle")
  var dutyCycle: Double = 0.5,
  @JsName("fmModFreq")
  var fmModFreq: Double = 0.0,
  @JsName("fmModAmp")
  var fmModAmp: Double = 0.0,
  @JsName("amModFreq")
  var amModFreq: Double = 0.0,
  @JsName("amModAmp")
  var amModAmp: Double = 0.0,
  @JsName("attack")
  var attack: Double = 0.1,
  @JsName("decay")
  var decay: Double = 0.2,
  @JsName("sustain")
  var sustain: Double = 0.5,
  @JsName("release")
  var release: Double = 0.2,
  @JsName("delay")
  var delay: Double = 0.0,
  @JsName("delayDepth")
  var delayDepth: Double = 0.0,
  @JsName("feedback")
  var feedback: Double = 0.0,
)
